/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-02 17:27:05
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import LayoutNavbar from '@root/components/LayoutNavbar';
import DefaultPackage from '@root/containers/DefaultPackage';

const DefaultPackagePage = () => {
  const { t } = useTranslation();
  return (
    <LayoutNavbar
      navbarProps={{
        title: t('subscription'),
      }}
      containerStyle={{ overflow: 'hidden' }}
    >
      <DefaultPackage />
    </LayoutNavbar>
  );
};

export default DefaultPackagePage;
